import { Ref, ref, computed } from "vue";
import { useRoute } from 'vue-router';
import Config from "@/const/Config";
import { KoyouKeiyakuService } from "@/service/KoyouKeiyakuService";

/*
 * 初期処理
 */
export function useInit() {
    const loading = ref(0) // APIで読み込みをする本数
    const isError = ref(false)

    const route = useRoute();
    const srv = new KoyouKeiyakuService()
    // 雇用契約PDF出力APIのURLを返す  // TODO:print()に雇用契約書IDを渡す
    // const getRuleURL = () => {
    //     const code = route.params.code as string
    //     return Config.API_URL + '/koyoukeiyaku/print';
    // }

    // 雇用契約IDから雇用契約添付ファイルテーブルから（履歴書）PDFのURLを返す
    const getPDFURL = async () => {
      // 雇用契約ID
      const koyouKeiyakuId = parseInt(route.params.id as string, 10);// TODO: パスからだと雇用契約IDとは限らないので治す
      const res = await srv.getRirekisyoUrl(koyouKeiyakuId)
      // TODO:エラーの場合の処理を記述
      if(res) {
        return res;
      }
      else {
        console.log('添付ファイルが存在しません。')
      }
    }
    
    // 雇用契約IDから雇用契約添付ファイルテーブルから（履歴書）PDFをダウンロードする
    const downloadPDF = () => {
      // 雇用契約ID
      const koyou_keiyaku_id = parseInt(route.params.id as string, 10);
      return Config.API_URL + '/koyoukeiyaku/download/' + koyou_keiyaku_id;
    }  

    // 読み込み中か判断する
    const isLoading = computed(() => {
        return !(loading.value === 0 || isError.value)
    })

    return {
        // getRuleURL,
        isLoading,
        isError,
        getPDFURL,
        downloadPDF,
    }
}
